/* eslint-disable max-len */
export const PCF_VERIFICATION_WARNING = {
  message: 'Third-party verification required.',
  description:
    'Your selected use is public-facing or regulatory. Per ISO 14067 §7.3, independent verification is required before publishing or making external claims.'
} as const;

export const PCF_VERIFICATION_WARNING_KEY = 'pcf-verification-warning';
